export default Object.freeze({
    LEASE_FLAGS: {
        EXEMPT_DELINQUENCY: 'exempt_delinquency',
        BLOCK_COMMUNICATION: 'block_all_communications',
    },
    CONTACT_FLAGS: {
        DO_NOT_RENT: 'do_not_rent',
    },
    EXEMPT_FLAG_TYPES: {
        LEASE: 'lease',
        CONTACT: 'contact',
    },
  });
  